(ns quuppa.pe-domain
  (:require [clojure.string :as str]))

;; QMD process predicates are in QMD directly
;; These are currently only used in peweb locators table

(defn locator->identification-status
  [{:keys [coordinate-system has-dummy-id
           id identification-wizard-id]}]
  (cond
    (nil? coordinate-system) "Runtime"
    (nil? identification-wizard-id) (if has-dummy-id "Not done" "Manual")
    (= "old" (str/lower-case identification-wizard-id)) "Unknown"
    (= id identification-wizard-id) "Wizard"
    has-dummy-id "Reset"
    :else "Changed manually"))

(defn locator->focusing-status
  [{:keys [coordinate-system orientation]
    :as locator}]
  (cond
    (nil? coordinate-system) "Runtime"
    (nil? (:azimuth-rad orientation)) "Not done"
    (:is-orientation-determined-manually orientation) "Manual confirmed"
    (:is-orientation-determined-by-orientation-tool orientation) (str "Wizard (" (:num-points (:orientation-data locator)) ")")
    :else "Manual unconfirmed"))
